













import { TypeBody } from '@bambeehr/pollen';
import { defineComponent, PropType } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'CTABladeBody',
  components: {
    TypeBody,
  },
  props: {
    description: {
      type: String as PropType<string>,
      required: false,
      default:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    },
    variant: {
      type: String as PropType<string>,
      required: false,
    },
    showButton: {
      type: Boolean as PropType<Boolean>,
      required: true,
    },
  },
  setup(props) {
    const isPadding = props.showButton ? '' : 'mb-[72px] md:mb-16';
    const bodyColor = props.variant === '' ? '#4E4B66' : props.variant;

    return {
      isPadding,
      bodyColor,
    };
  },
});
